// TODO-KPI-151: grup sırası değişince (hesap grubu "ilk tam grup" kuralı) hesap grubunun değiştiğini
// söyleyen amber bant — kaydedilmemiş taslakta, ağacın altında; aria-live=polite.

import { type CalcGroupChange } from "../../lib/calc-group-change";
import { KPI_BREAKDOWN_COPY } from "../../lib/kpi-breakdown-copy";

export function CalcGroupChangedBand(props: {
  changes: readonly CalcGroupChange[] | undefined;
}): JSX.Element | null {
  const list = props.changes ?? [];
  if (list.length === 0) return null;
  const C = KPI_BREAKDOWN_COPY.tree;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="kpi-set-calc-group-changed"
      className="rounded-lg text-sm mt-3"
      style={{
        padding: "8px 12px",
        border: "1px solid var(--color-warning-border)",
        background: "var(--color-warning-bg)",
        color: "var(--color-warning-text)",
      }}
    >
      <strong>{C.calcGroupChangedLead}</strong>
      <ul style={{ margin: "4px 0 0", paddingLeft: 18 }}>
        {list.map((c) => (
          <li key={`${c.totalLabel}|${c.from}|${c.to}`}>
            {C.calcGroupChanged(c.totalLabel, c.from, c.to)}
          </li>
        ))}
      </ul>
    </div>
  );
}
